import { Box, styled } from "@mui/material";

import { LinearGradients, StylingRelatedConstants } from "config";

import type { StyledLayoutContentWrapperProps } from "./types";

export const StyledMainLayout = styled(Box)(({ theme }) => ({
  display: "flex",
  padding: theme.spacing(3),
  background: LinearGradients.MAIN_LAYOUT,
}));

export const StyledLayoutContentWrapper = styled(Box, {
  shouldForwardProp: (prop) => !["whiteColorBackground"].includes(String(prop)),
})<StyledLayoutContentWrapperProps>(({ theme, whiteColorBackground }) => ({
  display: "flex",
  width: "100%",
  marginLeft: theme.spacing(3),
  marginTop: `calc(${theme.spacing(3)} + ${
    StylingRelatedConstants.TOPBAR_HEIGHT
  })`,
  ...(whiteColorBackground && {
    backgroundColor: theme.palette.custom.white,
  }),
  borderRadius: theme.shape.borderRadius[3],
  overflow: "hidden",
  position: "relative",
}));
